export const dollar = (x) =>
    `${new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(x)}`;